



































































































import { Vue, Component } from 'vue-property-decorator'
import { nanoid } from 'nanoid'

@Component
export default class Home extends Vue {
  private gameId = ''

  public canJoinGame(): boolean {
    return !!this.gameId
  }

  private newGame(): void {
    this.$router.push({
      name: 'game',
      params: {
        id: nanoid(10)
      }
    })
  }
  
  private joinGame(): void {
    this.$router.push({
      name: 'game',
      params: {
        id: this.gameId
      }
    })
  }
}
